
export const DomNodesTipService = Symbol.for('DomNodesTipService');

export interface DomNodesTipService {
    nodesMap: Record<string, HTMLElement[]>;
    currentIndexMap: Record<string, number>;
    tipInfoMap: Record<string, {
        number: number,
        length: number,
    }>;

    setTipRef(params: {
        ref: HTMLElement,
        id: string,
    }): void;

    setWrapperRef(params: {
        ref: HTMLElement,
        id: string,
    }): void;

    clearTip(id: string): void;

    initNodesTip(params: {
        selector: string,
        notFoundMessage?: string,
    }): void;
    closeTip(id: string): void;
    moveToTargetNode(params: {
        targetIdx?: number,
        moveType?: 'next' | 'prev',
        id: string,
    }): void;
}
